const selectorTypes: any[] = [
  { value: 'text' },
  { value: 'number' },
  { value: 'date' },
  { value: 'signature' },
  { value: 'barcode' },
  { value: 'photo' },
  {
    value: 'multi_option',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/multi-option.jpg',
  },
  {
    value: 'select_option_metadata',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/alternative-data.jpg',
  },
  {
    value: 'select_check_metadata',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/check-data.jpg',
  },
  {
    value: 'select_number_metadata',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/number-data.jpg',
  },
  {
    value: 'select_text_metadata',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/text-data.jpg',
  },
  {
    value: 'static_text',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/static-text.jpg',
  },
  {
    value: 'select_metadata',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/single-option-data.jpg',
  },
  { value: 'attachment' },
  { value: 'select_activity_period_time' },
  {
    value: 'table',
    pic: 'https://data-scope.s3-us-west-2.amazonaws.com/vendors/public/questions/subform.jpg',
  },
];

export { selectorTypes };
